import { render, staticRenderFns } from "./HotelFlightApp.vue?vue&type=template&id=788bc56c&scoped=true"
import script from "./HotelFlightApp.vue?vue&type=script&lang=js"
export * from "./HotelFlightApp.vue?vue&type=script&lang=js"
import style0 from "./HotelFlightApp.vue?vue&type=style&index=0&id=788bc56c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788bc56c",
  null
  
)

export default component.exports